<template>
	<div class="main-container">
		<my-header :isTransparent="isTransparent"></my-header>
		<div class="content-container">
			<transition name="fade-transform" mode="out-in">
				<keep-alive include="siUserMsg,siMsg"><router-view class="content"></router-view></keep-alive>
			</transition>
		</div>
		<transition name="fade"><side-bar v-if="sidebarShow"></side-bar></transition>
		<my-footer></my-footer>
	</div>
</template>

<script>
import SideBar from '@/views/layout/sidebar/sidebar.vue';
import MyHeader from '@/views/layout/header/header.vue';
import MyFooter from '@/views/layout/footer.vue';
export default {
	components: {
		MyHeader,
		MyFooter,
		SideBar
	},
	data() {
		return {
			sidebarShow: true,
			isTransparent: true //导航栏透明
		};
	},
	mounted() {
		window.addEventListener('scroll', this.scrolling);
		window.yzf &&
			window.yzf.init({
				sign: '37ef9b97807600c77745caea14e3b5308800d6eed05a1dbe15f7907a26d5dd443614f2bfe439cb5ff07233f875ed7fd2c46e6b50',
				uid: '',
				data: {
					c1: '',
					c2: '',
					c3: '',
					c4: '',
					c5: ''
				},
				selector: ['.chat-btn','#btnid'],
				callback: function(type, data) {}
			});
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrolling);
	},
	methods: {
		scrolling() {
			// 滚动条距文档顶部的距离
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// 滚动条滚动的距离
			let scrollStep = scrollTop - this.oldScrollTop;
			// 更新——滚动前，滚动条距文档顶部的距离
			this.oldScrollTop = scrollTop;
			//变量windowHeight是可视区的高度
			let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
			//变量scrollHeight是滚动条的总高度
			let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
			//滚动条到底部的条件
			if (scrollTop + windowHeight == scrollHeight) {
				this.scrollStatus = true;
				//你想做的事情
			}
			//滚动条向上滚动
			if (scrollStep < 0) {
				this.isTransparent = false;
			} else {
				this.isTransparent = false;
			}
			// 判断是否到了最顶部
			if (scrollTop <= 0) {
				this.isTransparent = true;
			}
			if (scrollTop - 150 <= 0) {
			}
		}
		// handleScroll () {
		//   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		//   if(scrollTop>=100){
		// 	  this.sidebarShow=true
		//   }else{
		// 	  this.sidebarShow=false
		//   }
		// },
	}
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
	opacity: 0;
}
.main-container {
	width: 100%;
	height: 100%;
}
.content-container {
	// padding-top: $global-header-height;
	width: 100%;
	min-height: calc(100% - 315px);
	.content {
		margin: auto;
		// height: 100% !important;
		min-height: calc(100vh - 400px);
	}
}
</style>
